import { render, staticRenderFns } from "./10e_doc.vue?vue&type=template&id=9a013f14&scoped=true"
import script from "./10e_doc.vue?vue&type=script&lang=js"
export * from "./10e_doc.vue?vue&type=script&lang=js"
import style0 from "./10e_doc.vue?vue&type=style&index=0&id=9a013f14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a013f14",
  null
  
)

export default component.exports